module.exports = __webpack_public_path__ + "media/assets/images/dots-2-3445298902ae50b8c7f8c75fc805d738.svg";